import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import DriverInfoGridConfig from "./GridConfig";
import DataGrid from '@dataGrid';
import CloseIcon from "@material-ui/icons/Close";
import SaveAltSharp from "@material-ui/icons/SaveAltSharp";
import styles from "./styles";
import { DRIVER_EVENTS, SHOW_DRIVER_EVENTS } from "../../constants";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  DialogActions,
  Button,
  IconButton,
} from "@material-ui/core";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import appConstants from "../../../../../../appConstants";
import {
  sortStopsBySequence,
  getTotalReturnDeliveryShipments,
  getPendingDeliveryShipments,
  getCompletedDeliveryShipments,
  getDailyAccruedHours,
  getWeeklyAccruedHours,
  fetchDriverImage,
  getDriverRouteSPHBPHCount,
  getFilteredDriverBreakDelays,
  getFilteredDriverBreakDelaysByDriverRoute,
  getTerminalDateWithOffset,
  getEquipmentSuffix,
} from "../../../utils/utils";
import RefreshWarningBar from "../../RefreshWarningBar";
import Events from "../../../../../../utilities/EventEmitter";
import { getSpecialNeedsOptionsWithServiceLevel, getGridFeatureFlagsByGridNames } from "../../../../utils";
import { csvFormulaInjectionSanitizer } from "../../../../../../utilities/csvUtils";
import DriverInfo from "./components/DriverInfo";
import { inject, observer } from "mobx-react";
import StopDetails from "./components/StopDetails";
import KPIContainer from "./components/KPIContainer";
import EquipmentContainer from "./components/EquipmentContainer";
import { CustomDropdown } from "../../DispatchPanel/EquipmentDefects/Grid/components";
import { isEqual } from "lodash/lang";
import {
  DRIVER_INFO_GRID_FILTER_OPTIONS,
  DRIVER_INFO_GRID_FILTERS,
} from "./constants";
import { withAppConfig } from "../../../../../../appConfigContext";
import { getDeptTimeForArrivedStopInMinutes, getLatestBreaks, isDriverTimeBeforeCurrentDateAndTime } from "../../utils";
import { getDriverStatus } from "../../utils/DriverStatus";
import { minutesToTime } from '@dataGrid/gridUtilities';
import DriverInfoTopSection from "./components/DriverInfoTopSection";
import { getDriverGateInAndOutTime } from "../../DriverPopUp/utils";
import { withFeatureFlags } from "../../../../../../userProfile/featureFlagsContext";
import { autorun } from "mobx";
import { getFormattedValue } from "./utils";
import DriverAppInfo from "./components/DriverAppInfo";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

@inject("DispatchStore","CommonStore")
@observer
class DriverInfoDialog extends React.Component {
  constructor(props) {
    super(props);
    const gridFeatureFlagConfig = getGridFeatureFlagsByGridNames(
      this.props.configJSON?.gridConfiguration,
      appConstants.gridNames.DispatchedDriverGrid
    );
    this.gridConfig = new DriverInfoGridConfig({
      userConfig: this.props.userData.userProfile?.columnPref,
      featureFlags: {
        enableColumnShortForm: this.props.configJSON?.enableColumnShortForm,
      },
    });
    this.gridApi = {};
    this.pickupIdToClosingTimeMapping = this.props.DispatchStore.pickupIdToClosingTimeMapping
    this.state = {
      pickupDeliveryInfo: {},
      stopData: null,
      driverInfo: this.props.driverInfo,
      currentDriverRoutes: this.getCurrentDriverRoutes(
        this.props.driverInfo.driverId,
      ),
      selectedStopType: DRIVER_INFO_GRID_FILTERS.PENDING,
      ...getLatestBreaks(this.props.driverInfo.delays),
      dailyAccruedHours : 0,
      weeklyAccruedHours : this.props.driverInfo.accruedHours,
      driversImage: {},
    };
    this.gridContext = {
      specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(props.priorityShipmentList),
      DispatchStore: this.props.DispatchStore,
      enableReturnExceptionReasonLabels: Boolean(
        this.props.configJSON?.enableReturnExceptionReasonLabels
      ),
      terminalCode: this.props.terminalCode,
      glEventHub: this.props.glEventHub,
      onCancel: this.props.onCancel,
      isEditPickupEnabled : this.props.featureFlags.isFeatureEnabled(appConstants.features.EnablePickupEdit),
      getClosingSoonPickupTime : this.getClosingSoonPickupTime,
      closingSoonLimitConfig: {
        closingSoonWarningTimeLimit: this.props.configJSON?.closingSoonWarningTimeLimit,
        closingSoonAlertTimeLimit: this.props.configJSON?.closingSoonAlertTimeLimit
      }
    };
    this.accruedHoursUpdateTimer = null;
    this.enableDriverZone =
      gridFeatureFlagConfig[
        appConstants.gridColumnFeatureFlag.DispatchedDriverGrid.EnableDriverZone
      ];
    this.enableWeeklyAccruedHours =
      gridFeatureFlagConfig[
        appConstants.gridColumnFeatureFlag.DispatchedDriverGrid.EnableWeeklyAccruedHours
      ];
    this.enablePickupGrouping = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnablePickupGrouping
    );
  }

  componentDidMount() {
    this.getStopInfo();
    this.displayStatus();
    this.updateAccruedHours();
    this.refreshAccruedHours();
    this.setDriverImage(this.props.driverInfo.driverNumber);
    this.autoRunClosingSoonPickups = autorun(() => {
      if (
        !isEqual(
          this.pickupIdToClosingTimeMapping,
          this.props.DispatchStore.pickupIdToClosingTimeMapping
        )
      ) {
        this.pickupIdToClosingTimeMapping = this.props.DispatchStore.pickupIdToClosingTimeMapping;
        this.gridApi?.refreshCells({ columns: ['stopType'], force: true });
      }
    })
  }

  componentDidUpdate() {
    if (!this.state.driverInfo.routeId) {
      return ;
    }
    const driverInfo = this.props.DispatchStore.getDispatchRoute(this.state.driverInfo.routeId);
    if (!isEqual(driverInfo, this.state.driverInfo)) {
      this.setState({
        driverInfo
      }, () => {
        this.getStopInfo();
        this.displayStatus();
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.accruedHoursUpdateTimer);
    this.accruedHoursUpdateTimer = null;
    this.autoRunClosingSoonPickups?.();
  }

  getClosingSoonPickupTime = (pickupId) => {
    return this.props.DispatchStore.getClosingSoonPickupTime(pickupId);
  }

  setDriverImage = async (driverNumber) => {
    let driverImage = this.state.driversImage[driverNumber]
    if (!driverImage) {
      driverImage = (
        await fetchDriverImage(
          [driverNumber],
          this.props.terminalCode
        )
      )[0]?.driverImage;
      this.setState(prevProps => ({
        ...prevProps,
        driversImage: {
          ...prevProps.driversImage,
          [driverNumber]: driverImage
        }
      }));
    }
  };

  refreshAccruedHours = () => {
    this.accruedHoursUpdateTimer = setInterval(() => {
      this.updateAccruedHours();
    }, appConstants.REFRESH_DRIVER_DURATION);
  };

  getNewAccruedHours = ({
    driverInfo,
    dailyAccruedHours,
    weeklyAccruedHours,
  }) => {
    const {
      accruedHours,
      driverClockedInTime,
      delays
    } = driverInfo;
    if (!driverClockedInTime) {
      return {dailyAccruedHours, weeklyAccruedHours};
    }
    const terminalOffset = this.props.DispatchStore.terminalOffset;
    const driverStartTimeInUtcTime = getTerminalDateWithOffset(
      driverClockedInTime,
      terminalOffset
    );
    if (!isDriverTimeBeforeCurrentDateAndTime(driverClockedInTime,terminalOffset)) {
      return { dailyAccruedHours, weeklyAccruedHours };
    }
    const newDailyAccruedHours = getDailyAccruedHours({
      driverStartTime: driverStartTimeInUtcTime,
      lunchBreakStops: getFilteredDriverBreakDelays(delays, appConstants.DELAY_STOP_TYPES.LUNCH_BREAK),
      terminalOffset,
    });
    const newWeeklyAccruedHours = getWeeklyAccruedHours(
      newDailyAccruedHours,
      accruedHours
    );
    return {
      dailyAccruedHours: newDailyAccruedHours,
      weeklyAccruedHours: newWeeklyAccruedHours
    };
  }

  updateAccruedHours = () => {
    const { dailyAccruedHours, weeklyAccruedHours } = this.getNewAccruedHours({
      driverInfo: this.state.driverInfo,
      dailyAccruedHours: this.state.dailyAccruedHours,
      weeklyAccruedHours: this.state.weeklyAccruedHours,
    });
    if (
      this.state.driverInfo.dailyAccruedHours !== dailyAccruedHours ||
      this.state.driverInfo.weeklyAccruedHours !== weeklyAccruedHours
    )
      this.setState({
        dailyAccruedHours,
        weeklyAccruedHours,
      });
  };

  getStopInfo = () => {
    const {driverInfo} = this.state;
    let pickupDeliveryInfo = {
      pickupPieces: 0,
      pickupWeight: 0,
      DeliveryPieces: 0,
      DeliveryWeight: 0,
    };
    driverInfo.stops.forEach((element) => {
      if (element.stopType === appConstants.STOP_TYPE.Delivery) {
        pickupDeliveryInfo.DeliveryPieces =
          pickupDeliveryInfo.DeliveryPieces + element.pieces;
        pickupDeliveryInfo.DeliveryWeight =
          pickupDeliveryInfo.DeliveryWeight + element.weight;
      } else {
        pickupDeliveryInfo.pickupPieces =
          pickupDeliveryInfo.pickupPieces + element.pieces;
        pickupDeliveryInfo.pickupWeight =
          pickupDeliveryInfo.pickupWeight + element.weight;
      }
    });
    this.setState({
      pickupDeliveryInfo: pickupDeliveryInfo,
    });
  };

  handleStopTypeChange = (stopType) => {
    this.setState({
      selectedStopType: stopType
    });
  }

  refreshGridData = () => {
    Events.emit(
      appConstants.DISPATCH_EVENTS.UPDATE_DISPATCH_DRIVER_ROUTES,
      this.state.driverInfo.driverId,
    );
  };

  exportCSV = () => {
    if (this.gridApi) {
      const params = {
        fileName: `driverInfoGrid`,
        processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value),
      };
      this.gridApi.exportDataAsCsv(params);
    }
  };
  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.gridApi.runCommand = this.runCommand
  };

  runCommand = ({action, pickupId}) => {
      if(action === "editPickup") {
        Events.emit("EditPickup", pickupId);
        this.props.onCancel();
      }
  }



  onMsgClick = () => {
    this.props.onMessageClick({ routeData: this.state.driverInfo });
    this.props.onCancel();
  };
  displayStatus = () => {
    const {driverInfo} = this.state;
    if (
      driverInfo.currentStatus &&
      [DRIVER_EVENTS.ArrivedAtStop, DRIVER_EVENTS.EnrouteToStop].includes(
        driverInfo.currentStatus.status,
      )
    ) {
      const stopData = driverInfo.stops.find(
        (stop) => stop.stopId === driverInfo.currentStatus?.stopId,
      );
      if (stopData) {
        stopData["event"] = `${SHOW_DRIVER_EVENTS[driverInfo.currentStatus.status]} ${
          stopData.stopType
        } Stop`;
        this.setState({ stopData: stopData });
      }
    } else if (
      driverInfo.currentStatus &&
      driverInfo.currentStatus.status === DRIVER_EVENTS.DelayStart
    ) {
      this.setState({
        stopData: {
          name: "Due to Lunch/Fuel break",
          event: SHOW_DRIVER_EVENTS.DelayStart,
        },
      });
    } else {
      this.setState({
        stopData: null,
      });
    }
  };

  getStopData = (stop, pro = null) => {
    return {
      stopId: stop.stopId,
      name: stop.name,
      address: stop.address,
      city: stop.city,
      state: stop.state,
      zip: stop.zip,
      pickupNumber: stop.pickupNumber,
      stopType: stop.stopType,
      isStopCompleted: stop.isStopCompleted,
      stopSequence: stop.stopSequence,
      deliveryWindow: stop.deliveryWindow, 
      actualArrivalTime: stop.actualArrivalTime,
      actualDepartureTime: stop.actualDepartureTime,
      loadingZone: stop.loadingZone,
      isApt: stop.isApt,
      plannedArrivalTime: stop.plannedArrivalTime,
      departureTime: stop.departureTime,
      shipments: pro?
        stop.shipments.filter((shipment) => {
          return shipment.shipmentId === pro.shipmentId;
        }) :stop.shipments,
    };
  };

  getPickupInfoGridData = (stopsList) => {
    const pickupInfoGridData = [];
    const {COMPLETED, PENDING} = DRIVER_INFO_GRID_FILTERS;
    const selectedStopStatusValue = this.state.selectedStopType.value;
    const { driverStatus } = getDriverStatus({
      data: this.state.driverInfo,
      context: this.props.DispatchStore.terminalOffset,
    },false);
    let arrivedStopId = null;
    if(DRIVER_EVENTS.ArrivedAtStop === driverStatus){
       arrivedStopId = this.state.driverInfo?.currentStatus?.stopId
    }
    stopsList.forEach((stop) => {
      const isArrivedStop = arrivedStopId && arrivedStopId === stop.stopId;
      if(isArrivedStop){
        stop = {
          ...stop,
          departureTime: minutesToTime({
            value: getDeptTimeForArrivedStopInMinutes({
              actualArrivalTime: stop?.actualArrivalTime,
              plannedArrivalTime: stop?.arrivalTime,
              plannedDeptTime: stop?.departureTime,
            }),
          }),
        };
      }
      if (
        [COMPLETED.value, PENDING.value].includes(selectedStopStatusValue) &&
        stop.isStopCompleted !== selectedStopStatusValue
      ) {
        return;
      }
      
      if (stop.stopType === appConstants.STOP_TYPE.Delivery) {
        if (stop.shipments.length) {
          pickupInfoGridData.push(
            ...stop.shipments.map((pro) => ({
              ...pro,
              ...this.getStopData(stop, pro),
            })),
          );
        } else {
          const additionalData = {
            weight: stop.weight,
            pieces: stop.pieces,
            specialInstructions: stop.specialInstructions ?? "",
          };
          pickupInfoGridData.push({ ...additionalData, ...this.getStopData(stop) });
        }
      }
      else if (this.enablePickupGrouping && stop.stopType === appConstants.STOP_TYPE.Pickup) {
        const shipmentsByPickupNumber = (stop.shipments ?? []).reduce((acc, shipment) => {
          if (shipment.pickupNumber) {
            if (!acc.has(shipment.pickupNumber)) acc.set(shipment.pickupNumber, []);
            acc.get(shipment.pickupNumber).push(shipment);
          }
          return acc;
        }, new Map());

        const driverId = this.state.driverInfo.driverId;
        const seenPickupNumbers = new Set();

        (stop.pickupNumberIdList ?? []).forEach(({ pickupNumber, pickupId }) => {
          if (!pickupNumber || seenPickupNumbers.has(pickupNumber)) return;
          seenPickupNumbers.add(pickupNumber);

          const shipmentData = shipmentsByPickupNumber.get(pickupNumber) ?? [];
          if (shipmentData.length) {
            const { weight, cube, pieces } = shipmentData.reduce(
              (acc, s) => ({ weight: acc.weight + s.weight, cube: acc.cube + s.cube, pieces: acc.pieces + s.pieces }),
              { weight: 0, cube: 0, pieces: 0 }
            );
            pickupInfoGridData.push({// row for each pickup
              ...stop,
              shipments: [shipmentData],
              pickupId: shipmentData[0].pickupId ?? null,
              pickupNumber: shipmentData[0].pickupNumber ?? null,
              weight,
              cube,
              pieces,
              driver: { driverId }
            });
          } else {
            pickupInfoGridData.push({// row for NF
              ...stop,
              shipments: [],
              pickupId,
              pickupNumber,
              isNoFreight: true,
              weight: null,
              cube: null,
              pieces: null,
              driver: { driverId }
            });
          }
        });
      } else {
        pickupInfoGridData.push({ ...stop, driver: {
          driverId: this.state.driverInfo.driverId 
        }
      });
      }
    });
    return pickupInfoGridData;
  };

  changeRouteData = (routeId) => {
    const showDriverStopListOnMap = this.state.currentDriverRoutes.find(
      (route) => route.routeId === routeId.value,
    );
    if (showDriverStopListOnMap) {
      this.setState({ driverInfo: showDriverStopListOnMap }, this.getStopInfo);
    }
  };

  getCurrentDriverRoutes = (driverId) => {
    return this.props.DispatchStore.routesList.filter((route) => route.driverId === driverId);
  };

  getDropdownOptions = (key) => {
    return this.state.currentDriverRoutes.map((route) => ({
      label: route[key],
      value: route.routeId,
      ...(key === "trailerNumber" && {
        labelSuffix: getEquipmentSuffix({
          equipmentScac: route.trailerScac,
          showTrailerScac: this.props.configJSON.showTrailerScac,
        }),
      }),
    }));
  };

  changeSelectedDriver = (option) => {
    if (!option) {
      return;
    }
    const driverId = option.value;
    const routeList = this.props.DispatchStore.currentActiveRoutes.slice();
    const driverInfo = routeList.find((route) => route.driverId === driverId);
    if (!driverInfo) {
      return;
    }
    const { dailyAccruedHours, weeklyAccruedHours } = this.getNewAccruedHours({
      driverInfo,
      dailyAccruedHours: 0,
      weeklyAccruedHours: 0,
    });
    this.setState({
      driverInfo,
      currentDriverRoutes: this.getCurrentDriverRoutes(driverId),
      ...getLatestBreaks(driverInfo.delays),
      dailyAccruedHours,
      weeklyAccruedHours
    }, () => {
      this.getStopInfo();
      this.displayStatus();
    });
    this.setDriverImage(driverInfo.driverNumber);
  };

  
  onCellClicked = (params) => {
    const selectedRow = this.gridApi.getSelectedRows()[0];
    if (selectedRow?.pickupId && params.column.colId === 'pickupNumber') {
      this.props.glEventHub.emit('showPickupDetails', selectedRow.pickupId);
      this.props.onCancel();
      return;
    }

    if (
      selectedRow &&
      params.column.colId === 'proId' &&
      selectedRow.stopType === appConstants.STOP_TYPE.Delivery
    ) {
      Events.emit('showProDetails', {
        stopId: selectedRow.stopId,
        proId: params.value,
        driverRouteDetails: this.state.driverInfo,
        shipmentId: selectedRow.shipmentId
      });
      this.props.onCancel();
    }
  };

  render() {
    const { classes } = this.props;
    const {
      driverInfo,
      dailyAccruedHours,
      weeklyAccruedHours,
    } = this.state;
    const routeStops = driverInfo?.stops?.length
      ? sortStopsBySequence(driverInfo.stops)
      : [];
    const pickupInfoGridData = this.getPickupInfoGridData(routeStops);
    const totalReturnDeliveryShipments =
      getTotalReturnDeliveryShipments(routeStops);
    const totalPendingDeliveryShipments =
      getPendingDeliveryShipments(routeStops);
    const totalCompletedDeliveryShipments =
      getCompletedDeliveryShipments(routeStops);
    const totalCompletedStops = routeStops.filter(
      (stop) => stop.isStopCompleted,
    ).length;
    const totalStops = routeStops.length;
    const currentDriverRouteNames = this.getDropdownOptions("routeName");
    const currentDriverManifests = this.getDropdownOptions("manifestNumber");
    const currentDriverTrailers = this.getDropdownOptions("trailerNumber");
    const { theme } = this.props.userData.userProfile || {};
    const driverRoutes = this.props.DispatchStore.getDriverRoutes(
      driverInfo?.driverId
    );
    return (
      <Dialog
        open
        aria-labelledby="CancelDispatch-title"
        classes={{ paper: classes.dialog }}
        maxWidth="lg"
        onClose={this.props.onCancel}
        className={`${classes.dialogWrapper} ${theme}`}
      >
        <DialogTitle
          id="CancelDispatch-title"
          classes={{ root: classes.dialogTitlestyle }}
          disableTypography
        >
          <span className={classes.dialogTitle}>Driver Information</span>
          <div className={classes.stopDropdown}>
            <DriverAppInfo driverInfo={driverInfo} userData={this.props.userData} />
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={this.props.onCancel}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent
          classes={{ root: classes.dialogContent }}
          className="customScroll"
        >
          <Grid container spacing={8}>
            <Grid item xs={2}>
              <DriverInfo
                driverInfo={driverInfo}
                driverImage={this.state.driversImage[driverInfo.driverNumber]}
                onMsgClick={this.onMsgClick}
                terminalOffset={this.props.DispatchStore.terminalOffset}
                changeSelectedDriver={this.changeSelectedDriver}
                dispatchedDriversList={
                  this.props.DispatchStore.dispatchedDriversList
                }
              />
            </Grid>
            <Grid item xs={10} className={classes.tableContainer}>
              <>
                <DriverInfoTopSection driverInfo={driverInfo}/>
                <div className={classes.topContainer}>
                  <EquipmentContainer
                    driverInfo={driverInfo}
                    currentDriverManifests={currentDriverManifests}
                    changeRouteData={this.changeRouteData}
                    currentDriverRouteNames={currentDriverRouteNames}
                    currentDriverTrailers={currentDriverTrailers}
                    showTrailerScac= {this.props.configJSON.showTrailerScac}
                  />
                  <KPIContainer
                    stopsPerHour={
                      getDriverRouteSPHBPHCount({
                        driverRoutes,
                        driverDispatchTime: driverInfo.driverDispatchTime,
                        terminalOffset: this.props.DispatchStore.terminalOffset,
                        lunchBreakStops:
                          getFilteredDriverBreakDelaysByDriverRoute({
                            delays:   driverInfo.delays,
                            driverRouteIds:  driverRoutes.map((driver) => driver.routeId),
                            delayType: appConstants.DELAY_STOP_TYPES.REST_BREAK
                          }
                          ),
                      }).stopsPerHour
                    }
                    dispatchZone= {driverInfo.dispatchZone}
                    enableDriverZone= {this.enableDriverZone}
                    delays={driverInfo.delays}
                    enableRestBreakInDelay={this.props.configJSON?.enableRestBreakInDelay}
                    weeklyAccruedHours={weeklyAccruedHours}
                    weeklyAllowedHOS={this.props.CommonStore.weeklyAllowedHOS}
                    dailyAllowedHOS={this.props.CommonStore.dailyAllowedHOS}
                    enableWeeklyAccruedHours={this.enableWeeklyAccruedHours}
                    dailyAccruedHours={dailyAccruedHours}
                    driverDispatchTime={driverInfo.driverDispatchTime}
                    {...getDriverGateInAndOutTime({
                      gateInTime: driverInfo.gateInTime,
                      gateOutTime: driverInfo.gateOutTime,
                    })}
                  />
                </div>
              </>

              <div className={classes.bottomContainer}>
                <StopDetails
                  stopData={{
                    toDo: getFormattedValue(totalStops - totalCompletedStops),
                    done: getFormattedValue(totalCompletedStops)
                  }}
                  pickupData={{
                    toDo: getFormattedValue(driverInfo.pendingPickups),
                    done: getFormattedValue(driverInfo.completedPickups),
                    pieces: this.state.pickupDeliveryInfo.pickupPieces,
                    weight: this.state.pickupDeliveryInfo.pickupWeight,
                  }}
                  deliveryData={{
                    toDo: getFormattedValue(totalPendingDeliveryShipments),
                    done: getFormattedValue(totalCompletedDeliveryShipments),
                    pieces: this.state.pickupDeliveryInfo.DeliveryPieces,
                    weight: this.state.pickupDeliveryInfo.DeliveryWeight,
                    returned: totalReturnDeliveryShipments,
                  }}
                />
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            item
            lg={12}
            md={12}
            xs={12}
            className={classes.infoDriverContainer}
          >
            <div className={classes.gridContainer}>
              <RefreshWarningBar
                onRefreshClick={this.refreshGridData}
                terminalOffset={this.props.DispatchStore.terminalOffset}
                driverId={driverInfo?.driverId.toUpperCase()}
              />
              <div className={classes.headerStyle}>
                <span className={classes.headerLabel}>Route</span>
                <div className={classes.stopDropdown}>
                  <div className={classes.dropdownInput}>
                    <CustomDropdown
                      autoFocus={false}
                      value={this.state.selectedStopType.label}
                      options={DRIVER_INFO_GRID_FILTER_OPTIONS}
                      onChange={this.handleStopTypeChange}
                    />
                  </div>
                  <ClearAllFilterButton gridApi={this.gridApi} />
                  <div className={classes.exportIcon}>
                    <SaveAltSharp
                      onClick={this.exportCSV}
                    />
                  </div>
                </div>
              </div>
              <div className={classes.dataGrid}>
                <DataGrid
                  defaultColDef={this.gridConfig.config.defaultColDef}
                  columnDefs={this.gridConfig.config.columns}
                  columnTypes={this.gridConfig.config.columnTypes}
                  config={this.gridConfig.config}
                  onGridReady={this.onGridReady}
                  rowSelection={this.gridConfig.config.rowSelection}
                  rowDeselection={this.gridConfig.config.rowDeselection}
                  rowData={pickupInfoGridData}
                  onCellClicked = {this.onCellClicked}
                  // onCellDoubleClicked={this.onCellDoubleClicked}
                  rowClassRules={this.gridConfig.config.rowClassRules}
                  context={this.gridContext}
                />
              </div>
            </div>
          </Grid>
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogAction }}>
          <Button
            color="primary"
            variant="outlined"
            className={classes.actionButton}
            onClick={this.props.onCancel}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default compose(
  withUserProfile,
  withStyles(styles),
  withAppConfig,
  withFeatureFlags
)(DriverInfoDialog);
